module.exports = __webpack_public_path__ + "img/r_rendering_icon_05.19125a5c.png";